export const ProductType = {
  SIMPLE: '간략 일정',
  DETAIL: '상세 일정',
} as const;

export type ProductType = keyof typeof ProductType;
